/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_Caption_Position_All_HelpInputs */

const en_apply_caption_position_all_help = /** @type {(inputs: Apply_Caption_Position_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update the caption position of all events in the selected event group.`)
};

const fr_apply_caption_position_all_help = /** @type {(inputs: Apply_Caption_Position_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour la position de tous les événements du groupe sélectionné.`)
};

const de_apply_caption_position_all_help = /** @type {(inputs: Apply_Caption_Position_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisieren Sie die Bildunterschriftenposition aller Ereignisse in der ausgewählten Ereignisgruppe.`)
};

const it_apply_caption_position_all_help = /** @type {(inputs: Apply_Caption_Position_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna la posizione della didascalia di tutti gli eventi nel gruppo selezionato.`)
};

const ru_apply_caption_position_all_help = /** @type {(inputs: Apply_Caption_Position_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить позицию подписи всех событий в выбранной группе событий.`)
};

const es_apply_caption_position_all_help = /** @type {(inputs: Apply_Caption_Position_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar la posición de subtítulo de todos los eventos en el grupo de eventos seleccionado.`)
};

const zh_cn2_apply_caption_position_all_help = /** @type {(inputs: Apply_Caption_Position_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新所选事件组中所有事件的标题位置。`)
};

const ja_apply_caption_position_all_help = /** @type {(inputs: Apply_Caption_Position_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントグループ内のすべてのイベントのキャプション位置を更新します。`)
};

const hi_apply_caption_position_all_help = /** @type {(inputs: Apply_Caption_Position_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित इवेंट समूह में सभी इवेंट्स की कैप्शन स्थिति अपडेट करें।`)
};

const pt_pt2_apply_caption_position_all_help = /** @type {(inputs: Apply_Caption_Position_All_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualize a posição da legenda de todos os eventos no grupo de eventos selecionado.`)
};

/**
* | output |
* | --- |
* | "Update the caption position of all events in the selected event group." |
*
* @param {Apply_Caption_Position_All_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_caption_position_all_help = /** @type {((inputs?: Apply_Caption_Position_All_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_Caption_Position_All_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_apply_caption_position_all_help(inputs)
	if (locale === "de") return de_apply_caption_position_all_help(inputs)
	if (locale === "it") return it_apply_caption_position_all_help(inputs)
	if (locale === "ru") return ru_apply_caption_position_all_help(inputs)
	if (locale === "es") return es_apply_caption_position_all_help(inputs)
	if (locale === "zh-CN") return zh_cn2_apply_caption_position_all_help(inputs)
	if (locale === "ja") return ja_apply_caption_position_all_help(inputs)
	if (locale === "hi") return hi_apply_caption_position_all_help(inputs)
	if (locale === "pt-PT") return pt_pt2_apply_caption_position_all_help(inputs)
	return en_apply_caption_position_all_help(inputs)
});